import { Injectable, WritableSignal, signal } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { setDefaultOptions } from 'date-fns';
import { TranslocoService } from '@jsverse/transloco';
import { locale, ngLocale } from '../constant/locale.constant';
import { Country, RegionCountry } from '../interfaces/country.interface';

@Injectable({ 
  providedIn: 'root' 
})
export class CountryService {

  public readonly regionCountry: RegionCountry[] = [
    {
      name: 'Global',
      countries: [{ code: 'GO', name: 'Global', langCodes: [ 'EN' ] }]
    },
    {
      name: 'Southeast Asia',
      countries: [{ code: 'ID', name: 'Indonesia', langCodes: [ 'ID', 'EN' ] }]
    }
  ];
  public readonly activeCountry: WritableSignal<Country> = signal({ code: 'ID', name: 'Indonesia', langCodes: [ 'ID', 'EN' ]});
  public readonly activeLanguage: WritableSignal<string> = signal('ID');

  constructor(
    protected readonly translocoService: TranslocoService
  ) { }

  public init(): void{
    if (!localStorage) {
      this.setActiveCountry(this.regionCountry[1].countries[0]);
      return;
    }

    try {
      const stored = localStorage.getItem('activeCountry');
    
      if (!stored) this.setActiveCountry(this.regionCountry[1].countries[0]);
      else {
        let isExisted = false;
        const country: Country = JSON.parse(stored);
        const language = localStorage.getItem('activeLang');

        for (let i = 0; i < this.regionCountry.length; i++){
          const ec = this.regionCountry[i].countries.find(({ code }) => code === country.code);
          
          if (ec) {
            isExisted = true;
            this.setActiveCountry(ec);
            
            if (language && ec.langCodes.includes(language)) this.setActiveLanguage(language);

            break;
          }
        }
        if (!isExisted) this.setActiveCountry(this.regionCountry[1].countries[1]);
      }
    } catch (_) {
      this.setActiveCountry(this.regionCountry[1].countries[0]);
    }
  }

  public setActiveCountry(c: Country): void{
    this.activeCountry.set(c);
    this.setActiveLanguage(c.langCodes[0]);
    localStorage?.setItem('activeCountry', JSON.stringify(c));
  }

  public setActiveLanguage(l: string): void{
    this.activeLanguage.set(l);
    localStorage?.setItem('activeLang', l);

    registerLocaleData(ngLocale[l], 'id');
    setDefaultOptions({ locale: locale[l] });
    this.translocoService.setActiveLang(l.toLowerCase());
  }
}
